import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ContractTemplateFieldNameService } from './contract-template-field-name.service';
const service = new ContractTemplateFieldNameService();

export interface ContractTemplateFieldNameState {}

const ContractTemplateFieldNameStore: Module<ContractTemplateFieldNameState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getContractTemplateFieldNames(context) {
         const response = await service.getContractTemplateFieldNames();
         return response.data;
      },
   },
};

export default ContractTemplateFieldNameStore;
